var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChatVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0,0,256,256",
    width: "256px",
    height: "256px",
    fillRule: "nonzero",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#007ffe",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    },
    id: "g2"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)",
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,2c-12.682,0 -23,10.318 -23,23c0,12.682 10.318,23 23,23c12.683,0 23,-10.318 23,-23c0,-12.682 -10.317,-23 -23,-23zM34.973,29.535c2.237,1.986 2.702,2.695 2.778,2.816c0.927,1.47 -1.028,1.649 -1.028,1.649h-4.12c0,0 -1.003,0.011 -1.86,-0.557c-1.397,-0.915 -2.86,-2.689 -3.888,-2.381c-0.863,0.258 -0.855,1.424 -0.855,2.421c0,0.357 -0.307,0.517 -1,0.517c-0.693,0 -0.981,0 -1.288,0c-2.257,0 -4.706,-0.76 -7.149,-3.313c-3.456,-3.609 -6.487,-10.879 -6.487,-10.879c0,0 -0.179,-0.366 0.016,-0.589c0.221,-0.25 0.822,-0.218 0.822,-0.218l3.995,-0.001c0,0 0.376,0.071 0.646,0.261c0.223,0.156 0.347,0.454 0.347,0.454c0,0 0.671,2.216 1.526,3.629c1.67,2.758 2.447,2.828 3.014,2.531c0.828,-0.43 0.558,-3.362 0.558,-3.362c0,0 0.037,-1.259 -0.395,-1.82c-0.333,-0.434 -0.97,-0.665 -1.248,-0.701c-0.225,-0.029 0.151,-0.423 0.63,-0.648c0.64,-0.285 1.511,-0.358 3.013,-0.344c1.169,0.011 1.506,0.081 1.962,0.186c1.379,0.318 1.038,1.157 1.038,4.103c0,0.944 -0.13,2.271 0.582,2.711c0.307,0.19 1.359,0.422 3.231,-2.618c0.889,-1.442 1.596,-3.834 1.596,-3.834c0,0 0.146,-0.263 0.373,-0.393c0.232,-0.133 0.225,-0.13 0.543,-0.13c0.318,0 3.507,-0.025 4.207,-0.025c0.699,0 1.355,-0.008 1.468,0.402c0.162,0.589 -0.516,2.607 -2.234,4.797c-2.823,3.594 -3.136,3.258 -0.793,5.336z",
    id: "path1"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      strokeWidth: 0.471455
    },
    d: "m 115.63326,173.46517 c -12.61233,-1.64058 -24.267616,-8.66522 -34.237157,-20.63473 -4.185525,-5.02518 -10.320532,-14.1447 -14.950062,-22.22286 -3.896481,-6.79905 -13.43944,-25.9618 -14.645723,-29.40937 -0.60231,-1.721402 -0.576692,-1.861846 0.498408,-2.73241 1.069219,-0.865801 1.834175,-0.909845 13.517931,-0.778323 l 12.384578,0.139411 1.404402,1.346287 c 0.983859,0.943145 1.922526,2.849015 3.134678,6.364645 4.537125,13.15911 12.959638,25.91278 18.137215,27.46402 2.32079,0.69532 4.46845,-0.0672 5.43083,-1.92825 1.23362,-2.38557 1.79745,-7.52226 1.52595,-13.90201 -0.30465,-7.15872 -0.91469,-9.99678 -2.52125,-11.72937 -1.30005,-1.40205 -4.41362,-3.12622 -5.699434,-3.15613 -1.404058,-0.0327 2.446594,-3.093953 4.713054,-3.746911 2.92379,-0.842337 17.6755,-1.182687 21.23416,-0.489912 7.31786,1.424585 7.38944,1.591214 7.38944,17.201803 0,7.37955 0.20629,12.91492 0.52908,14.19684 0.60217,2.39146 2.66858,4.44529 4.47251,4.44529 6.39269,0 16.18605,-13.26591 21.67676,-29.36297 2.5416,-7.451179 1.19071,-6.93906 18.30426,-6.93906 16.89495,0 16.58266,-0.08099 16.16996,4.19349 -0.52124,5.39868 -5.37124,14.51271 -12.57054,23.62235 -11.12162,14.07273 -11.63072,14.98187 -10.14393,18.11504 0.51455,1.08433 3.96675,4.64139 9.0775,9.35324 14.32394,13.20593 16.57092,17.24318 11.10679,19.95614 -1.6553,0.82186 -2.95419,0.89851 -15.01282,0.88586 -16.58792,-0.0174 -15.48503,0.34583 -26.87293,-8.85052 -5.9688,-4.82013 -7.9595,-5.96338 -10.56138,-6.06533 -3.83879,-0.15042 -5.68636,2.39303 -6.01741,8.28385 -0.31708,5.64238 -0.38644,5.82688 -2.40094,6.38634 -2.02333,0.56191 -10.73312,0.55818 -15.07393,-0.006 z",
    id: "path2"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatVk);
export default __webpack_public_path__ + "static/media/icon_chat_vk.56d66949b152a7b245129f1822d37392.svg";
export { ForwardRef as ReactComponent };